import { atom, useAtom } from "jotai";
import { State } from "./State";
import { fetchBase, postBase } from "./BaseApi";

export type Badge = {
  quizId: string;
  title: string;
  completedDate: string;
  acquiredBadgeType: string;
  badgeImageData: string;
  badgeExplanation: string;
};

export type UsersBadge = {
  userId: string;
  badgeList: Badge[];
};

type Param = {
  isCompleted: boolean;
};

const uri = "api/users/badge";

export const fetchUsersBadgeAtom = atom<State<UsersBadge> | null>(null);
export const fetchUsersBadge = () => {
  return fetchBase<UsersBadge, Param>(uri, fetchUsersBadgeAtom);
};
